module.exports = __webpack_public_path__ + "resources/img/img_ahnlabv3_net_server.f09c2ef73817634a59c3f95e38de9141.png";